module.exports = __webpack_public_path__ + "img/opel_sw.bf9ba8cb.png";